import { FC } from "react";
import { MapLegendItem } from "../@types/common";
import { BREAKPOINTS } from "../constants/common";
import { useWindowSize } from "../hooks/useWindowWidth";
interface mapLegendProps {
  items: MapLegendItem[];
}
const MapLegend: FC<mapLegendProps> = ({ items }: mapLegendProps) => {
  const windowWidth = useWindowSize();
  const { EXTRA_LARGE } = BREAKPOINTS;
  return (
    <div>
      {items.map((item, i) => {
        return (
          <div
            key={i}
            className={`flex flex-row items-center text-darkBlue ${
              windowWidth < EXTRA_LARGE ? "py-[5px]" : "py-[1px] my-3"
            }`}
          >
            <div
              className={`rounded-full flex-none ${item.color} ${
                windowWidth < EXTRA_LARGE ? "w-[10px] h-[10px]" : "w-m h-m"
              }`}
            ></div>
            <p
              className={`grow w-[70%] pr-2 ${
                windowWidth < EXTRA_LARGE ? "text-[13px]" : "text-[16px]"
              }`}
            >
              {item.text}
            </p>
            <p
              className={`flex-none ${
                windowWidth < EXTRA_LARGE ? "text-[13px]" : "text-[16px]"
              }`}
            >
              {item.percent}%
            </p>
          </div>
        );
      })}
    </div>
  );
};
export default MapLegend;